import React from 'react';

import { TextField as MuiTextField } from '@mui/material';

import { getFieldError, getFieldWarning, hasFieldError } from 'src/utils/finalForm';

import type { TextFieldProps } from './interface';

const TextField: React.FC<TextFieldProps> = React.forwardRef(
  (
    {
      input,
      meta,
      disabled,
      warning,
      showErrorOnlyTouched = true,
      showErrorWhenDisabled = true,
      ...rest
    },
    ref,
  ) => {
    const { name, value, onBlur, onChange } = input;

    const handleChange = React.useCallback(
      (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onChange(event.target.value);
      },
      [onChange],
    );

    const error = hasFieldError(meta, showErrorOnlyTouched);
    const showError = showErrorWhenDisabled || !disabled;
    const helperText = showError
      ? getFieldError(meta, showErrorOnlyTouched) || getFieldWarning(value, meta, warning, disabled)
      : '';

    return (
      <MuiTextField
        name={name}
        value={value}
        error={showError ? error : false}
        helperText={helperText}
        onChange={handleChange}
        onBlur={onBlur}
        variant="outlined"
        type={input.type}
        disabled={disabled}
        inputRef={ref}
        {...rest}
      />
    );
  },
);

export { TextField };
